import { useQuery } from "@tanstack/react-query";
import { getAllAssetInsights, GetAllAssetInsightsReq, getAllSceneInsights, GetAllSceneInsightsReq } from "./api";
import { AssetInsight, SceneInsight } from "./types/insight.type";

/*
 * useGetAllAssetInsights Query
 *
 * This query is used to get all insights for every asset in a study.
 *
 * Query Key: [projectId, studyId, "insights", sortBy, orderBy]
 */
export const useGetAllAssetInsights = ({ projectId, studyId, sortBy, orderBy }: GetAllAssetInsightsReq, options?: { enabled?: boolean }) => {
  return useQuery<AssetInsight[]>({
    queryKey: [projectId, studyId, "asset-insights", sortBy, orderBy],
    throwOnError: true,
    queryFn: () => getAllAssetInsights({ projectId, studyId, sortBy, orderBy }),
    ...options,
  });
};

/**
 * useGetAllSceneInsights Query
 *
 * This query is used to get all insights for every scene in a study.
 *
 * Query Key: [projectId, studyId, "scene-insights", sortBy, orderBy]
 */
export const useGetAllSceneInsights = ({ projectId, studyId, sortBy, orderBy }: GetAllSceneInsightsReq, options?: { enabled?: boolean }) => {
  return useQuery<SceneInsight[]>({
    queryKey: [projectId, studyId, "scene-insights", sortBy, orderBy],
    throwOnError: true,
    queryFn: () => getAllSceneInsights({ projectId, studyId, sortBy, orderBy }),
    ...options,
  });
};
